import axios from 'axios'
import CardPin from 'components/CardPin'
import { apiEndpoint } from 'configs'
import { useSnackbar } from 'notistack'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { URL_DETAIL_TRANSACTION } from 'utils/pathUrl'

const CheckPinTrx = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { enqueueSnackbar } = useSnackbar()
  const datas = location.state
  const [loading, setLoading] = useState(false)
  const [errMsg, setErrMsg] = useState('')
  const { token } = useSelector((e) => e.auth)
  const { profile, ownerData } = useSelector((e) => e.dashboard)
  const lastPathBeforeNavigate = localStorage.getItem('lastPathBeforeNavigate')

  const handleSubmit = async (pin) => {
    try {
      setLoading(true)
      const { data } = await axios.post(
        `${apiEndpoint}/api/v1/bussines/checkpasswordtrx`,
        { pin: pin },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )

      if (data?.success === 1 && data.tempToken) {
        if (datas?.userData?.trxId) {
          const isTalangin = Boolean(
            datas?.dataState?.useTalangin ||
              datas?.userData?.paymentMethod === 1,
          )
          const isCOD = datas?.userData?.paymentMethod === 3
          const isPayable = datas?.userData?.paymentMethod === 2
          const isUangBelanja = datas?.userData?.paymentMethod === 0

          const obj = {
            tempToken: data.tempToken,
            id: datas?.userData?.trxId,
            selfieurl: datas?.selfieUrl?.url,
            ...(isCOD && {
              useProofOfPayment: true,
              paymentTime: 'onDelivery',
            }),
            ...(isTalangin && {
              loanDays: datas?.dataState?.selectedTenor?.loanDays,
              creditRequested: datas?.dataState?.dataTenor?.creditRequested,
            }),
            ...(datas?.isCash &&
              datas?.userData?.useProofOfPayment && {
                useProofOfPayment: datas?.userData?.useProofOfPayment,
                proofOfPayment: Object.keys(datas?.userData || {}).includes(
                  'proofOfPayment',
                )
                  ? datas?.userData?.proofOfPayment
                  : undefined,
              }),
            ...(isPayable && {
              usePayable: true,
            }),
            ...((isCOD || isTalangin || isUangBelanja || datas?.isCash) &&
              !isPayable && {
                usePayable: false,
              }),
            ...((isPayable || isTalangin || isUangBelanja || datas?.isCash) &&
              !isCOD &&
              !datas?.isCash && {
                useProofOfPayment: false,
                paymentTime: null,
              }),
            ...((isCOD || isPayable || isUangBelanja || datas?.isCash) &&
              !isTalangin && {
                loanDays: null,
                creditRequested: null,
              }),
            ...(datas?.userData?.project && {
              project: datas?.userData?.project,
            }),
          }
          const res = await axios.post(
            `${apiEndpoint}/api/v2/bussines/transaction/payment`,
            obj,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          )
          if (res.status === 200) {
            localStorage.removeItem('userData')
            const uId = profile?.userId || ownerData?.userId || datas?.userData?.userId || datas?.dataProfile?.ownerData?.userId
            if (uId) {
              localStorage.removeItem(`userData-${uId}`)
              localStorage.removeItem(`userDataBuy-${uId}`)
            } else {
              Object.keys(localStorage).forEach((key) => {
                if (key.startsWith('userData-') || key.startsWith('userDataBuy-')) {
                  localStorage.removeItem(key)
                }
              })
            }
            handleSavedContacts(datas?.userData?.dataSeller)
            setLoading(false)
            // navigate('/transaksi-pembelian-sukses')
            enqueueSnackbar('Pembayaran Anda sudah diterima!', {
              variant: 'success',
            })
            setTimeout(() => {
              navigate(lastPathBeforeNavigate || '/')
            }, 300)
          }
        } else {
          const isTalangin = Boolean(
            datas?.dataState?.useTalangin ||
              datas?.userData?.paymentMethod === 1,
          )
          const isCOD = datas?.userData?.paymentMethod === 3
          const isPayable = datas?.userData?.paymentMethod === 2
          const isUangBelanja = datas?.userData?.paymentMethod === 0

          const buyerData =
            datas?.dataProfile?.ownerData ||
            ownerData ||
            profile?.data?.ownerData

          const picId =
            datas?.userData?.dataSeller?.otherPicUserId ||
            buyerData?.otherPicUserId ||
            datas?.userData?.dataSeller?.otherPicUser?.userId ||
            buyerData?.otherPicUser?.userId

          const obj = {
            tempToken: data.tempToken,
            userId: buyerData?.userId,
            selfieurl: datas?.selfieUrl?.url,
            item: datas?.userData?.dataComodities?.map((e) => {
              return {
                SKU: e?.comodity?.sku ?? e?.comodity?.SKU,
                // nameItem: e?.comodity?.label,
                // imageUrl: e?.comodity?.img ?? e?.comodity?.linkFoto,
                unit: e?.unit?.value,
                amount: Number(
                  e.quantity
                    ?.replace?.(/\./g, '')
                    ?.replace?.(/,/g, '.')
                    ?.slice?.(0, 15),
                ),
                price: Number(
                  e.price
                    ?.replace?.(/\./g, '')
                    ?.replace?.(/,/g, '.')
                    ?.slice?.(0, 15),
                ),
              }
            }),
            order: {
              type: 'BUY',
              transaction_number: datas?.userData?.customNumber,
              note: datas?.userData?.notes,
              ...(datas?.isManual && {
                unconfirmed: true,
                proofOfPayment: '',
                useProofOfPayment: false,
              }),
              ...(isCOD && {
                useProofOfPayment: true,
                paymentTime: 'onDelivery',
              }),
              ...((isPayable || isTalangin || isUangBelanja || datas?.isCash) &&
                !isCOD &&
                !datas?.isCash && {
                  useProofOfPayment: false,
                  paymentTime: null,
                }),
              ...(datas?.userData?.alreadyReceived && {
                autoRelease: datas?.userData?.alreadyReceived,
              }),
              ...(datas?.userData?.files.length > 0 && {
                escrowFiles: datas?.userData?.files,
              }),
              ...(datas?.userData?.additionalFiles?.length > 0 && {
                files: datas?.userData?.additionalFiles,
              }),
              ...(datas?.selectedPricing && {
                useDisbursementpricingId: datas?.selectedPricing?.id,
              }),
              ...(datas?.isCash &&
                datas?.userData?.useProofOfPayment && {
                  useProofOfPayment: datas?.userData?.useProofOfPayment,
                  proofOfPayment: datas?.userData?.proofOfPayment,
                }),
              ...(isPayable && {
                usePayable: true,
              }),
              ...((isCOD || isTalangin || isUangBelanja || datas?.isCash) &&
                !isPayable && {
                  usePayable: false,
                }),
            },
            buyer: {
              fullName: buyerData?.name || buyerData?.fullName,
              phoneNumber: buyerData?.phoneNumber,
              userId: buyerData?.userId,
            },
            seller: {
              fullName: datas?.userData?.dataSeller?.fullName,
              phoneNumber: datas?.userData?.dataSeller?.phoneNumber,
              bankCode: datas?.userData?.dataSeller?.bankCode,
              bankAccountName: datas?.userData?.dataSeller?.bankAccountName,
              bankAccountNumber: datas?.userData?.dataSeller?.bankAccountNumber,
              isLogin: datas?.userData?.dataSeller?.isLogin ?? false,
              ...(datas?.userData?.dataSeller?.status === 'REGISTERED' && {
                userId: datas?.userData?.dataSeller?.userId,
              }),
            },
            ...(isTalangin && {
              loanDays: datas?.dataState?.selectedTenor?.loanDays,
              creditRequested: datas?.dataState?.dataTenor?.creditRequested,
            }),
            ...((isCOD || isPayable || isUangBelanja || datas?.isCash) &&
              !isTalangin && {
                loanDays: null,
                creditRequested: null,
              }),
            trxDate: datas?.userData?.trxDate,
            ...(datas?.userData?.project && {
              project: datas?.userData?.project,
            }),
            ...(picId && {
              otherPicUserId: picId,
            }),
          }
          const res = await axios.post(
            `${apiEndpoint}/api/v2/bussines/transaction/buy`,
            obj,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          )
          if (res.status >= 200 && res.status < 300) {
            const escrowpaymentId =
              res.data?.data?.escrowpaymentId || res.data?.escrowpaymentId
            if (!escrowpaymentId && !res.data?.data?.id && !res.data?.id) {
              setErrMsg('Transaksi berhasil dibuat, tetapi ID transaksi tidak ditemukan.')
              setLoading(false)
              return
            }
            if (datas?.selectedPricing) {
              localStorage.setItem(
                'PMB_isInstant',
                JSON.stringify(datas?.selectedPricing),
              )
            } else {
              localStorage.removeItem('PMB_isInstant')
            }
            localStorage.removeItem('userData')
            const uId = profile?.userId || ownerData?.userId || datas?.userData?.userId || datas?.dataProfile?.ownerData?.userId
            if (uId) {
              localStorage.removeItem(`userData-${uId}`)
              localStorage.removeItem(`userDataBuy-${uId}`)
            } else {
              Object.keys(localStorage).forEach((key) => {
                if (key.startsWith('userData-') || key.startsWith('userDataBuy-')) {
                  localStorage.removeItem(key)
                }
              })
            }
            setLoading(false)
            handleSavedContacts(datas?.userData?.dataSeller)
            if (datas?.isCash) {
              enqueueSnackbar('Transaksi berhasil dibuat!', {
                variant: 'success',
              })
              setTimeout(() => {
                if (escrowpaymentId) {
                  navigate(`${URL_DETAIL_TRANSACTION}/${escrowpaymentId}?type=BUY`)
                } else {
                  navigate(lastPathBeforeNavigate || '/')
                }
              }, 300)

              // enqueueSnackbar('Pembayaran Anda sudah diterima!', {
              //   variant: 'success',
              // })
              // navigate('/transaksi-pembelian-sukses', {
              //   state: {
              //     title: 'Transaksi berhasil dibuat!',
              //     desc: 'Setelah penjual melakukan konfirmasi, transaksi akan selesai otomatis.',
              //   },
              // })
            } else {
              enqueueSnackbar('Transaksi berhasil dibuat!', {
                variant: 'success',
              })
              setTimeout(() => {
                if (escrowpaymentId) {
                  navigate(`${URL_DETAIL_TRANSACTION}/${escrowpaymentId}?type=BUY`)
                } else {
                  navigate(lastPathBeforeNavigate || '/')
                }
              }, 300)
              // navigate('/transaksi-pembelian-sukses')
            }
          }
        }
      } else {
        navigate(-1)
      }
    } catch (error) {
      setLoading(false)
      setErrMsg(
        error?.response?.data?.message ??
          error?.response?.data?.meta?.message ??
          error?.message,
      )
      enqueueSnackbar(
        `${
          error?.response?.data?.message ??
          error?.response?.data?.meta?.message ??
          error?.message
        }`,
        {
          variant: 'error',
        },
      )
    }
  }

  const handleSavedContacts = (e) => {
    const saved =
      JSON.parse(localStorage.getItem(`savedContacts-${profile?.userId}`)) ?? []
    let newListComodities = [...saved]

    const updatedOptions = newListComodities.filter(
      (item) => item.userId !== e.userId,
    )

    updatedOptions.unshift(e)

    if (updatedOptions.length > 5) {
      const removedItem = updatedOptions.pop()

      newListComodities = {
        removedItem,
      }
    }

    localStorage.setItem(
      `savedContacts-${profile?.userId}`,
      JSON.stringify(updatedOptions),
    )
  }

  return (
    <div style={{ backgroundColor: 'white', width: '100%' }} data-testid="confirm-pin">
      <CardPin
        title={`Konfirmasi PIN`}
        desc={` Masukkan PIN untuk melanjutkan`}
        testIdPrefix="confirm-pin"
        length={6}
        handleSubmit={handleSubmit}
        loading={loading}
        errMsg={errMsg}
        setErrMsg={setErrMsg}
        minHeight="90vh"
        inputType="password"
        showResetPin={true}
      />
    </div>
  )
}

export default CheckPinTrx
